import { Component, input } from '@angular/core';
import { Dict } from '@shared/models';

@Component({
  selector: 'b2c-button',
  styleUrl: './button.component.scss',
  templateUrl: './button.component.html',
})
export class ButtonComponent {
  styles = input<Dict>({});
  title = input<string>('');
  loading = input<boolean>(false);
  disabled = input<boolean>(false);
  buttonType = input<string>('button');
  cssClass = input<string>('btn-primary');
  loadingBorderColor = input<string>('#ffffff');
}
